/*
 * pc-bundle-cart-guard.js — removes orphaned / unearned Bundle Builder gift lines.
 *
 * A bundle's gift is a SEPARATE cart line, freed by the discount Function only
 * while its own bundle instance is present (the Function pairs gift ↔ bundle by
 * the per-add `_pc_bundle_group` token). So if a shopper deletes a bundle's line,
 * its gift is left behind AND is no longer discounted — this guard then removes
 * any bundle gift line that isn't actually free, so shoppers are never charged
 * for a leftover gift. Self-contained; safe to no-op when cart data is absent.
 */
(function () {
  if (typeof fetch !== "function") return;
  var running = false;

  function readCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(
      function (r) {
        return r.json();
      },
    );
  }

  function removeLine(key) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }

  function guard() {
    if (running) return;
    running = true;

    readCart()
      .then(function (cart) {
        if (!cart || !cart.items) return null;

        // A bundle gift line that ended up NOT discounted = orphaned/unearned.
        var removals = cart.items
          .filter(function (line) {
            var props = line.properties || {};
            return (
              props._pc_bundle_role === "gift" && !(line.total_discount > 0)
            );
          })
          .map(function (line) {
            return line.key;
          });

        if (!removals.length) return null;

        // Remove sequentially, then ask the theme to re-render the cart.
        return removals.reduce(function (chain, key) {
          return chain.then(function () {
            return removeLine(key);
          });
        }, Promise.resolve());
      })
      .then(function (didChange) {
        if (didChange) {
          document.dispatchEvent(new CustomEvent("cart:build"));
        }
      })
      .catch(function () {
        /* best-effort: never break the cart */
      })
      .then(function () {
        running = false;
      });
  }

  // React to the theme's cart lifecycle. Debounced; the `running` flag plus the
  // no-change early return prevent a re-render loop.
  ["cart:build-complete", "ajaxProduct:added", "cart:updated"].forEach(function (
    evt,
  ) {
    document.addEventListener(evt, function () {
      setTimeout(guard, 300);
    });
  });
})();
